import React from 'react';

import { useMultiProvider } from './MultiProvider';
import SecurityProvider from './SecurityProvider';
import { useOkta } from './providers';
import { msalInstance, MsalProvider } from './providers/MS';

const OktaAuthProvider = ({ children }) => {
  const oktaAuth = useOkta();
  return (
    <SecurityProvider auth={oktaAuth} isPartner={false}>
      {children}
    </SecurityProvider>
  );
};

const PartnerAuthProvider = ({ children }) => {
  const multiAuth = useMultiProvider();

  return (
    <SecurityProvider auth={multiAuth} isPartner={true}>
      {children}
    </SecurityProvider>
  );
};

export const GgSecurity = ({ children, isPartner }) => {
  if (isPartner) {
    return (
      <MsalProvider instance={msalInstance}>
        <PartnerAuthProvider>{children}</PartnerAuthProvider>
      </MsalProvider>
    );
  }

  return <OktaAuthProvider>{children}</OktaAuthProvider>;
};
